var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-mz-coloring"},[_c('div',{style:(_vm.imageStyle)},[_c('canvas',{ref:"canvasImage",staticClass:"coloring-canvas",attrs:{"width":_vm.startGameConfig.configGame.image.width,"height":_vm.startGameConfig.configGame.image.height},on:{"mousedown":_vm.clickOnCanvas}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }